import React, { lazy } from 'react';
import { withRouter } from 'react-router-dom';

import { ReactComponent as EmptyCart } from 'assets/icons/empty-cart.svg';

import Button from 'components/button';

import { Payment } from 'containers/EventItemPage/elements';

import { useStateValue } from 'context/store';
import { closeCart } from 'context/cart/actions';

import { numberFormat } from 'utils/stringUtil';

import {
  CheckCircle,
  Close,
  DrawerBody,
  DrawerHeader,
  Wrapper,
  CartFooter,
  NoItemsDisplay
} from './elements';
import { trackInitiateCheckout } from 'utils/analyticsUtil';

const CartItem = lazy(() =>
  import(/* webpackChunkName: "CartItem" */ './CartItem')
);

function Content({ history }) {
  const {
    state: { cart, eventItem, checkout },
    dispatch
  } = useStateValue();

  const { items, total, currencyValue } = cart;
  const { isFree } = eventItem;
  const { promoItems } = checkout;

  sessionStorage.setItem('items', JSON.stringify(items));
  sessionStorage.setItem('total', JSON.stringify(total));
  sessionStorage.setItem('currencyValue', JSON.stringify(currencyValue));
  sessionStorage.setItem('isFree', JSON.stringify(isFree));
  sessionStorage.setItem('promoItems', JSON.stringify(promoItems));

  function handleCheckout() {
    history.push('/checkout');
    trackInitiateCheckout(items);
    dispatch(closeCart());
  }

  const cartHasNonFreeItem = items.some(item => !item.ticketIsFree);

  function handlefooter() {
    return Array.isArray(items) && items.length ? (
      <CartFooter>
        {cartHasNonFreeItem ? (
          <Payment>
            <div className="subtotal">
              <p>Total</p>
              <p>
                {currencyValue} {numberFormat(total)}
              </p>
            </div>
            <Button width="100%" color="yellow" onClick={handleCheckout}>
              Checkout
            </Button>
          </Payment>
        ) : (
          <Payment>
            <Button width="100%" color="yellow" onClick={handleCheckout}>
              RSVP
            </Button>
          </Payment>
        )}
      </CartFooter>
    ) : null;
  }

  return (
    <Wrapper>
      <DrawerHeader>
        <div style={{ display: 'flex' }}>
          {Array.isArray(items) && items.length ? (
            <>
              <CheckCircle />
              <div className="header">
                <h3 className="header-title">Items Added to Cart</h3>
              </div>
            </>
          ) : null}
        </div>
        <Close onClick={() => dispatch(closeCart())} />
      </DrawerHeader>
      <DrawerBody empty={!items.length > 0}>
        {Array.isArray(items) && items.length > 0 ? (
          items.map(item => <CartItem key={item.id} item={item} />)
        ) : (
          <NoItemsDisplay>
            <EmptyCart />
            <h2>No Items</h2>
          </NoItemsDisplay>
        )}
        {handlefooter()}
      </DrawerBody>
    </Wrapper>
  );
}

export default withRouter(Content);
